import { gql } from '@apollo/client';

export const ORG_TEASER_LARGE_FRAGMENT = gql`
  fragment OrganizationTeaserLargeFragment on OrganizationProfileParagraph {
    bundle
    rowTitle: title
    rowSubtitle: subtitle
    background
    organizationProfile {
      name
      url {
        path
      }
      organizationLocation {
        address
        countryCode
        addressLine1
        locality
        zip
        lat
        lon
      }
      size {
        tid
        label
      }
      industry {
        tid
        label
      }
      organizationJobsCount
      logo(style: "job_squared_logo_medium") {
        url
        alt
        title
      }
      cover(style: "organization_large_teaser") {
        url
        alt
        title
        width
        height
      }
    }
  }
`;

export default ORG_TEASER_LARGE_FRAGMENT;
